import ProjectDetailPage from '@/app/projects/ProjectDetailPage'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, Link } from '@tanstack/react-router'
import { TriangleAlert } from 'lucide-react'

const RouteComponent = () => {
  const { projectId } = Route.useParams()

  const companyId = LocalStorage.selectedCompany()?.id

  if (String(companyId) !== String(projectId)) {
    return <div className='flex flex-col items-center justify-center h-full'>
      <TriangleAlert className='text-error size-20 mb-4' />
      <div className='text-center text-xl text-balance [&_a]:text-primary [&_a]:hover:text-primary/80 [&_a]:underline [&_a]:transition'>
        Yalnızca seçili olan şirketin detaylarına erişebilirsiniz. 
        Detayları görüntülemek istediğiniz şirketi seçmek için 
        {' '}
        <Link to='/project-select'>Proje Seçim Sayfasına</Link>
        {' '}
        gidebilirsiniz
          veya seçili şirketin detaylarına erişmek için
        {' '}
        <Link to={`/project-detail/${companyId}`}>buraya tıklayabilirsiniz</Link>.
      </div>
    </div>
  }

  return <ProjectDetailPage projectId={projectId} />
}

export const Route = createFileRoute('/_auth/_withProject/project-detail/$projectId')({
  component: RouteComponent,
})
